import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { SelectOption } from '@forms/select/select.component';
import { FormService } from '@shared/services/form.service';
import { Subscription } from 'rxjs';

export interface FormField {
  name: string;
  type?: 'input' | 'textarea' | 'select';
  hasPasswordMeter?: boolean;
  selectOptions?: SelectOption[];
  height?: number;
}

@Component({
  selector: 'rav-form',
  templateUrl: './form.component.html',
  styleUrls: ['./form.component.scss']
})
export class FormComponent implements OnDestroy {
  @Input() formGroup: FormGroup;
  @Input() fields: FormField[];
  @Input() buttonText = 'Submit';
  @Input() hasCancel = false;
  @Input() hasSubmit = true;
  @Input() successMessage = '';
  @Input() isButtonDisabled: boolean;
  @Output() formSubmit = new EventEmitter<any>();
  @Output() cancel = new EventEmitter<void>();

  isPasswordVisible = false;
  isSubmitting = false;
  formSubscription: Subscription = null;

  constructor(private formService: FormService) {
    this.formSubscription = this.formService.formSubmit$.subscribe((submitting) => (this.isSubmitting = submitting));
  }
  ngOnDestroy() {
    if (this.formSubscription) {
      this.formSubscription.unsubscribe();
    }
  }

  isPasswordField(fieldName: string): boolean {
    switch (fieldName) {
      case 'old_pass':
      case 'new_password':
      case 'pass':
      case 'password':
      case 'pass_conf':
      case 'password_confirmation':
        return true;
      default:
        return false;
    }
  }
}
